<template>
	<card :title="title" class="wcPromotion">
		<div>
			<div v-for="(element, i) in sections" :key="i">
				<o-button
					@click="ClickDelete(element)"
					size="small"
					variant="danger"
					:disabled="element.deleting"
					icon-left="trash-alt"
					v-if="$store.getters.isEditing"></o-button>
				<wc-section-view
					:parent="uuid"
					:section="element"
					:filters="globalFilters"
					:editing="$store.getters.isEditing"
					@UpdateSection="UpdateSection"></wc-section-view>
			</div>
			<div class="addSection my-5" v-if="$store.getters.isEditing" @click="OpenAddSection">
				Add Widget
			</div>
		</div>
	</card>
</template>
<script>
	import { ref, watch, inject, computed, onMounted } from "vue";
	import { useRoute, useRouter } from "vue-router";
	import editPageSectionsModal from "@/components/modals/editPageSectionsModal.vue";
	import store from "@/store";
	import pageData from "@/store/pageData";

	export default {
		setup(props, context) {
			const $http = inject("$http");
			const $oruga = inject("$oruga");
			const route = useRoute();

			const title = ref("");

			const UpdateSection = (form) => {
				const section = pageData.page.value.Sections.find((o) => o.UUID === form.uuid);
				section.Width = form.result.width;
				section.Title = form.result.title;
				section.Text = form.result.text;
				section.Attributes = form.result.attrs;
				section.ToVueRouterName = form.result.to;
			};

			const OpenAddSection = () => {
				pageData.api.value.OpenAddSection(true);
			};

			const ClickDelete = async (element) => {
				element.deleting = true;
				await pageData.api.value.ClickDelete(element);
				element.deleting = false;
			};

			const uuid = computed(() => {
				return pageData.page.value?.UUID;
			});

			const sections = computed({
				get() {
					return (pageData.page.value?.Sections || []).filter((x) => x.IsDrawer == true);
				},
				set(newValue) {
					pageData.SetSections(newValue, true);
				}
			});

			const globalFilters = computed(() => {
				return {
					UsersFilter: pageData.page.value.UsersFilter,
					AssignmentsFilter: pageData.page.value.AssignmentsFilter,
					CompaniesFilter: pageData.page.value.CompaniesFilter,
					Parent: {
						UsersFilter: pageData.page.value.Parent?.UsersFilter,
						AssignmentsFilter: pageData.page.value.Parent?.AssignmentsFilter,
						CompaniesFilter: pageData.page.value.Parent?.CompaniesFilter
					}
				};
			});

			// watch(
			// 	() => pageData.page.value,
			// 	(n, o) => {
			// 		if (n !== o && n) {
			// 			//GetPromo();
			// 		}
			// 	}
			// );

			return {
				title,
				uuid,
				sections,
				globalFilters,
				UpdateSection,
				OpenAddSection,
				ClickDelete
			};
		}
	};
</script>
<style lang="scss" scoped>
	@import "@/assets/css/globalVars.scss";

	.wcPromotion {
		& .addSection {
			padding: 2em;
			border: 1px dashed #000;
			max-width: 240px;
			text-align: center;

			&:hover {
				background-color: $color-background-dark;
				cursor: pointer;
			}
		}
	}
</style>
